import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  InjectionToken,
  Input,
  Output,
} from '@angular/core';

import { ConnectionPositionPair } from '../../core/overlay/overlay.module';

export interface IconHelpWithDropdownTranslations {
  clickForHelp: string;
  learnMore: string;
  contactSupport: string;
}

export const IconHelpWithDropdownTranslationsToken = new InjectionToken<IconHelpWithDropdownTranslations>(
  'Translations for IconHelpWithDropdown',
);

@Component({
  selector: 'rt-icon-help-with-dropdown',
  templateUrl: 'icon-help-with-dropdown.component.html',
  styleUrls: ['./icon-help-with-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-padding]': 'withPadding',
    '[class.inline]': 'inline',
    '(click)': 'toggleDropdown()',
  },
})
export class IconHelpWithDropdownComponent {
  @Input() public link: string;
  @Input() public infoText: string;
  @Input() public contactSupport: boolean = false;
  @Input() public withPadding: boolean = false;
  @Input() public inline: boolean = false;
  @Input()
  public positions: ConnectionPositionPair[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top' },
  ];

  @Output() public readMoreClick: EventEmitter<void> = new EventEmitter();
  @Output() public openIntercom: EventEmitter<void> = new EventEmitter();

  public dropdownOpen: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    @Inject(IconHelpWithDropdownTranslationsToken)
    public translations: IconHelpWithDropdownTranslations,
  ) {}

  public toggleDropdown(state: boolean | undefined = undefined): void {
    this.dropdownOpen = state === undefined ? !this.dropdownOpen : state;
    this.cdRef.detectChanges();
  }

  public handleLinkClick(): void {
    this.toggleDropdown(false);
    this.readMoreClick.emit();
  }

  public openIntercomChat(): void {
    this.openIntercom.emit();
  }
}
